<template>
  <div class="mb-3">
    <text-input v-model="form.company" :error="form.errors.company" label="Company" />
    <div class="row">
      <div class="col-md-2">
        <person-title v-model="form.title" :error="form.errors.title"></person-title>
      </div>
      <div class="col-md-3">
        <text-input v-model="form.first_name" :error="form.errors.first_name" label="Firstname" />
      </div>
      <div class="col-md-3">
        <text-input v-model="form.middle_name" :error="form.errors.middle_name" label="Middle name" />
      </div>
      <div class="col-md-4">
        <text-input v-model="form.last_name" :error="form.errors.last_name" label="Lastname" />
      </div>
    </div>

    <text-input v-model="form.address_1" :error="form.errors.address_1" label="Address line 1" />
    <text-input v-model="form.address_2" :error="form.errors.address_2" label="Address line 2" />

    <div class="row">
      <div class="col-md-6">
        <text-input v-model="form.postal_code" :error="form.errors.postal_code" label="Postal Code" />
      </div>
      <div class="col-md-6">
        <text-input v-model="form.city" :error="form.errors.city" label="City" />
      </div>
    </div>

    <div class="mb-3">
      <text-input v-model="form.state" :error="form.errors.state" label="State" />
    </div>

    <div class="mb-3">
      <SelectCountry v-model="form.country" :error="form.errors.country" label="Country" />
    </div>

    <text-input v-model="form.email" :error="form.errors.email" label="E-mail address" />
    <text-input v-model="form.website" :error="form.errors.website" label="Website" />
    <text-input v-model="form.phone" :error="form.errors.phone" label="Phone" />
    <text-input v-model="form.cell_phone" :error="form.errors.cell_phone" label="Cellphone" />
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectCountry from '@/Shared/SelectCountry'
import PersonTitle from '@/components/Form/PersonTitle'

export default {
  name: 'CustomerForm',
  components: {
    SelectCountry,
    TextInput,
    PersonTitle,
  },
  props: {
    form: Object
  }
}
</script>

<style>

</style>
